export const environment = {
  API_URL: 'https://sign.obd.com.ar',
  AUTH_TOKEN: '6de5492e3de62bfdb934416bf2fb3586c2828e7b',
};
